import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { notifyError, notifyTopRight } from "../Common/Toaster";
import { createCategory } from "../../../services/UserServices/UserService";

const AddFaqCategory = ({ show, table, onHide }) => {
  const [formData, setFormData] = useState({
    title: "",
    title_ch: "",
    title_zh: "",
    title_ms: "",
    title_id: "",
    title_vi: "",
    title_ko: "",
    title_ja: "",
    title_hi: "",
  });
  const [errors, setErrors] = useState({ title: "", title_ch: "", title_zh: "", title_ms: "", title_id: "", title_vi: "", title_ko: "", title_ja: "", title_hi: "" });

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      try {
        await createCategory(formData);
        notifyTopRight("Created Successfully.");
        onHide();
        table();
      } catch (error) {
        notifyError(error.response?.data?.message || "An error occurred");
        console.error("Error:", error.response || error);
      }
    }
  };

  const validateForm = () => {
    let isValid = true;
    const errorObj = { title: "", title_ch: "" };
    if (!formData.title.trim()) {
      errorObj.title = "This field is required";
      isValid = false;
    }
    if (!formData.title_ch.trim()) {
      errorObj.title_ch = "This field is required";
      isValid = false;
    }
    if (!formData.title_zh.trim()) {
      errorObj.title_zh = "This field is required";
      isValid = false;
    }
    if (!formData.title_ms.trim()) {
      errorObj.title_ms = "This field is required";
      isValid = false;
    }
    if (!formData.title_id.trim()) {
      errorObj.title_id = "This field is required";
      isValid = false;
    }
    if (!formData.title_vi.trim()) {
      errorObj.title_vi = "This field is required";
      isValid = false;
    }
    if (!formData.title_ko.trim()) {
      errorObj.title_ko = "This field is required";
      isValid = false;
    }
    if (!formData.title_ja.trim()) {
      errorObj.title_ja = "This field is required";
      isValid = false;
    }
    if (!formData.title_hi.trim()) {
      errorObj.title_hi = "This field is required";
      isValid = false;
    }

    setErrors(errorObj);
    return isValid;
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <form onSubmit={handleSubmit}>
        <div className="modal-header">
          <h4 className="modal-title fs-20">Add Category</h4>
        </div>
        <div className="modal-body">
          <div className="form-group mb-3">
            <label className="text-black font-w500">
              Category Name (English)
            </label>
            <input
              type="text"
              className="form-control"
              value={formData.title}
              onChange={(e) => {
                setFormData({ ...formData, title: e.target.value });
                setErrors({ ...errors, title: "" });
              }}
            />
            {errors.title && (
              <div className="text-danger fs-12">{errors.title}</div>
            )}
          </div>
          <div className="form-group mb-3">
            <label className="text-black font-w500">
              Category Name (Chinese)
            </label>
            <input
              type="text"
              className="form-control"
              value={formData.title_ch}
              onChange={(e) => {
                setFormData({ ...formData, title_ch: e.target.value });
                setErrors({ ...errors, title_ch: "" });
              }}
            />
            {errors.title_ch && (
              <div className="text-danger fs-12">{errors.title_ch}</div>
            )}
          </div>
          <div className="form-group mb-3">
            <label className="text-black font-w500">
              Category Name (Chinese traditional)
            </label>
            <input
              type="text"
              className="form-control"
              value={formData.title_zh}
              onChange={(e) => {
                setFormData({ ...formData, title_zh: e.target.value });
                setErrors({ ...errors, title_zh: "" });
              }}
            />
            {errors.title_zh && (
              <div className="text-danger fs-12">{errors.title_zh}</div>
            )}
          </div>
          <div className="form-group mb-3">
            <label htmlFor="title_ms" className="text-black font-w500">Category Name(Malay bahasa melayu)</label>
            <input
              className="form-control"
              value={formData.title_ms}
              onChange={(e) => {
                setFormData({ ...formData, title_ms: e.target.value });
                setErrors({ ...errors, title_ms: "" });
              }}
            />
            {errors.title_ms && (
              <div className="text-danger fs-12">{errors.title_ms}</div>
            )}
          </div>
          <div className="form-group mb-3">
            <label htmlFor="title_id" className="text-black font-w500">Category Name (Indonesian bahasa indonesia)</label>
            <input
              className="form-control"
              value={formData.title_id}
              onChange={(e) => {
                setFormData({ ...formData, title_id: e.target.value });
                setErrors({ ...errors, title_id: "" });
              }}
            />
            {errors.title_id && (
              <div className="text-danger fs-12">{errors.title_id}</div>
            )}
          </div>
          <div className="form-group mb-3">
            <label htmlFor="title_vi" className="text-black font-w500">Category Name (Vietnamese)</label>
            <input
              className="form-control"
              value={formData.title_vi}
              onChange={(e) => {
                setFormData({ ...formData, title_vi: e.target.value });
                setErrors({ ...errors, title_vi: "" });
              }}
            />
            {errors.title_vi && (
              <div className="text-danger fs-12">{errors.title_vi}</div>
            )}
          </div>
          <div className="form-group mb-3">
            <label htmlFor="title_ko" className="text-black font-w500">Category Name (Korean)</label>
            <input
              className="form-control"
              value={formData.title_ko}
              onChange={(e) => {
                setFormData({ ...formData, title_ko: e.target.value });
                setErrors({ ...errors, title_ko: "" });
              }}
            />
            {errors.title_ko && (
              <div className="text-danger fs-12">{errors.title_ko}</div>
            )}
          </div>

          <div className="form-group mb-3">
            <label htmlFor="title_ja" className="text-black font-w500">Category Name (Japanese)</label>
            <input
              className="form-control"
              value={formData.title_ja}
              onChange={(e) => {
                setFormData({ ...formData, title_ja: e.target.value });
                setErrors({ ...errors, title_ja: "" });
              }}
            />
            {errors.title_ja && (
              <div className="text-danger fs-12">{errors.title_ja}</div>
            )}
          </div>
          <div className="form-group mb-3">
            <label htmlFor="title_hi" className="text-black font-w500">Category Name (Hindi)</label>
            <input
              className="form-control"
              value={formData.title_hi}
              onChange={(e) => {
                setFormData({ ...formData, title_hi: e.target.value });
                setErrors({ ...errors, title_hi: "" });
              }}
            />
            {errors.title_hi && (
              <div className="text-danger fs-12">{errors.title_hi}</div>
            )}
          </div>
        </div>
        <div className="modal-footer">
          <button type="submit" className="btn btn-primary">
            Submit
          </button>
          <button type="button" onClick={onHide} className="btn btn-secondary">
            <i className="flaticon-delete-1"></i> Cancel
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default AddFaqCategory;
